
import { AssessmentResponse } from '@/types/assessment';
import { supabase } from '@/integrations/supabase/client';
import { extractSelectedCareers } from './careerRecommendationService';

/**
 * Extract student information needed for report generation
 */
export const extractStudentInfo = async (userId: string, responses: AssessmentResponse[]) => {
  // Get user profile for student information
  const { data: userProfile } = await supabase
    .from('profiles')
    .select('name, education_status')
    .eq('id', userId as string)
    .single();

  // Get selected careers
  const selectedCareers = extractSelectedCareers(responses);
  
  // Safely extract profile data
  return {
    name: (userProfile as any)?.name || 'Student',
    educationStatus: (userProfile as any)?.education_status || 'Not Specified',
    selectedCareers
  };
};
